import React from 'react';
import Header from './Header';
import Footer from './Footer';
import SmoothScroll from './motion/SmoothScroll';
import { MainContent, PageShell } from '../styles/primitives';

function Layout({ children }) {
  return (
    <PageShell>
      <SmoothScroll />
      <Header />
      <MainContent>{children}</MainContent>
      <Footer />
    </PageShell>
  );
}

export default Layout;
